import React, { Fragment, PureComponent } from "react";
import { Button, Input, message, Form } from "antd";
import { Helmet } from "react-helmet";
import LoginVideo from "../assets/geospatial/images/Login/login.mp4";
import { unlockExpiredPassword } from "../apis/userManagement/user_reset_password";
import swal from "sweetalert";
import { clear } from "../util/Storage";

class ExpiredPassword extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      new_password: "",
    };
  }

  onInputChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  resetPassword = async (values) => {
    try {
      const body = {
        old_password: values.old_password,
        password: values.new_password,
        confirm_password: values.confirm_password,
      };
      const swalPrompt = await swal({
        text: `Click OK to New Password`,
        icon: "info",
        buttons: true,
        dangerMode: true,
      });
      if (swalPrompt) {
        await unlockExpiredPassword(body);
        swal(`Success New Password User`, {
          icon: "success",
          buttons: false,
        });
        setTimeout(() => {
          clear();
          window.location.href = "/";
        }, 1000);
      }
    } catch (error) {
      console.log(error, "error");
      const errorMsg = error?.response?.data?.message || error?.message;
      if (errorMsg.includes("PASSWORD_MUST_BE_AT_LEAST_6_CHARACTERS")) {
        message.error("Password must be at least 6 characters");
      } else if (
        errorMsg.includes("PASSWORD_MUST_CONTAIN_AT_LEAST_ONE_DIGIT")
      ) {
        message.error("Password must contain at least one digit");
      } else if (
        errorMsg.includes("PASSWORD_MUST_CONTAIN_AT_LEAST_ONE_UPPERCASE_LETTER")
      ) {
        message.error("Password must contain at least one uppercase letter");
      } else if (
        errorMsg.includes("PASSWORD_MUST_CONTAIN_AT_LEAST_ONE_LOWERCASE_LETTER")
      ) {
        message.error("Password must contain at least one lowercase letter");
      } else if (
        errorMsg.includes("PASSWORD_MUST_CONTAIN_AT_LEAST_ONE_SYMBOL")
      ) {
        message.error("Password must contain at least one symbol");
      } else {
        message.error("Failed to reset password, Please try again.");
      }
    }
  };
  render() {
    const { new_password } = this.state;
    return (
      <Fragment>
        <Helmet>
          <meta charSet="UTF-8" />
          <title>Change Password - Geospatial Analytics Center</title>
        </Helmet>
        <div className="gx-app-login-wrap gx-login-background">
          <video autoPlay loop muted id="myVideo">
            <source src={LoginVideo} type="video/mp4" />
          </video>
          <div className="gx-app-login-container">
            <div className="gx-app-login-main-content">
              <div className="gx-app-login-content">
                <div className="gx-login-header">
                  <h1>Buat Kata Sandi Baru</h1>
                </div>
                <Form
                  layout="vertical"
                  onFinish={(values) => {
                    this.resetPassword(values);
                  }}
                >
                  <Form.Item label="Old Password" name="old_password">
                    <Input.Password
                      placeholder="Input Old Password"
                      onChange={this.onInputChange}
                      name="old_password"
                      type="password"
                    />
                  </Form.Item>
                  <Form.Item label="New Password" name="new_password">
                    <Input.Password
                      placeholder="Input New Password"
                      onChange={this.onInputChange}
                      name="new_password"
                    />
                  </Form.Item>
                  <Form.Item
                    label="Confirm Password"
                    name="confirm_password"
                    dependencies={["new_password"]}
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: "Please confirm your password!",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (
                            !value ||
                            getFieldValue("new_password") === value
                          ) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error(
                              "The two passwords that you entered do not match!"
                            )
                          );
                        },
                      }),
                    ]}
                  >
                    <Input.Password
                      placeholder="Input Confirm Password"
                      onChange={this.onInputChange}
                      name="confirm_password"
                    />
                  </Form.Item>

                  <div className="ant-modal-footer">
                    {new_password === undefined || new_password === "" ? (
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{ float: "right" }}
                        disabled
                      >
                        Save
                      </Button>
                    ) : (
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{ float: "right" }}
                      >
                        Save
                      </Button>
                    )}
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default ExpiredPassword;
